import { modifier } from 'ember-modifier';
export default modifier((element, [attribute, condition, value]) => {
  if (condition) {
    element.setAttribute(attribute, value);
  } else {
    element.removeAttribute(attribute);
  }
});